<template>
  <div class="toolbar-icon">
    <add-view-dialog />
    <views-drop-down :items="viewList" :title="$t('title.setView')" :active-index="activeViewIndex">
      <custom-icon :class-name="activeView.icon" :is-loading="isLoading" />
    </views-drop-down>
  </div>
</template>

<script>
import AddViewDialog from "./AddViewDialog.vue";
import ViewsDropDown from "./ViewsDropDown.vue";
import CustomIcon from "../../commons/CustomIcon.vue";

export default {
  components: {
    AddViewDialog,
    ViewsDropDown,
    CustomIcon,
  },
  data() {
    return {
      DropDownVisibility: false,
    };
  },
  computed: {
    isLoading() {
      return this.$store.state.views.isLoading;
    },
    activeViewIndex() {
      // Find the index of the active view among allViews
      const activeViewId = this.$store.state.views.activeView?._id;
      return this.$store.state.views.allViews.findIndex((view) => view._id === activeViewId);
    },
    viewList() {
      let newViews = this.$store.state.views.allViews.map((view) => {
        return { ...view, func: this.setActiveView, id: view._id };
      });
      newViews = [
        ...newViews,
        {
          id: newViews.length + 1,
          title: "Add View",
          icon: "icon-plus",
          func: this.addView,
          style: { color: "#4caf50" },
        },
      ];
      return newViews;
    },
    activeView() {
      return this.$store.state.views.activeView;
    },
  },
  methods: {
    addView() {
      this.$store.dispatch("views/setShowAddViewDialog", true);
    },
    setActiveView(item) {
      this.$store.dispatch("views/setActiveView", item.id);
    },
    callFunc() {
      this.$store.dispatch("views/toggleViewsVisibility");
    },
  },
};
</script>
